import React, { PureComponent } from 'react';
import { Treemap, ResponsiveContainer } from 'recharts';

import {TreemapDataProcess} from './TreemapData';


const COLORS = ['#8889DD', '#3036e3','#F8C12D','#8DC77B', '#177517'];

class CustomizedContent extends PureComponent {
  render() {
    const {
      root, depth, x, y, width, height, index, colors, name,
    } = this.props;

    return (
      <g>
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          style={{
            fill: depth < 2 ? colors[Math.floor(index / root.children.length * 6)] : 'none',
            stroke: '#fff',
            strokeWidth: 2 / (depth + 1e-10),
            strokeOpacity: 1 / (depth + 1e-10),
          }}
        />
        {
          depth === 1 ? (
            <text
              x={x + width / 2}
              y={y + height / 2 + 7}
              textAnchor="middle"
              fill="#fff"
              fontSize={14}
            >
              {name}
            </text>
          ) : null
        }
        {
          depth === 1 ? (
            <text
              x={x + 4}
              y={y + 18}
              fill="#fff"
              fontSize={16}
              fillOpacity={0.9}
            >
              {index + 1}
            </text>
          ) : null
        }
      </g>
    );
  }
}

export default class TreeMapCard extends PureComponent {
  //static jsfiddleUrl = 'https://jsfiddle.net/alidingling/Ldvvz2ak/';

  render() {
    let data = TreemapDataProcess();

    //console.log(JSON.stringify(data))
    return (
      <ResponsiveContainer width="100%" height={400}>
      <Treemap
        width={400}
        height={200}
        data={data}
        dataKey="size"
        ratio={4 / 3}
        stroke="#fff"
        fill="#8884d8"
        content={<CustomizedContent colors={COLORS} />}
      />
        </ResponsiveContainer>
    );
  }
}
